"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeStyle = mergeStyle;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.assign.js");
function mergeStyle() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return styles.reduce(function (merged, style) {
    return style ? Object.assign(merged, style) : merged;
  }, {});
}